import { debounce } from 'lodash';

import React from 'react';
import styled from 'styled-components';

export interface OverlayProps extends React.AllHTMLAttributes<HTMLDivElement> {
  handleClick: Function;
}

export const StyledOverlay = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.25);
  animation: ${({ theme }) => theme.animations.opacity} 0.2s ease-in-out
    forwards;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const DEBOUNCE_TIME = 5;

const OverlayComponent = ({
  handleClick: _handleClick,
  children,
}: OverlayProps) => {
  const handleClick = debounce(() => _handleClick(), DEBOUNCE_TIME);

  return <StyledOverlay onClick={handleClick}>{children}</StyledOverlay>;
};

export default OverlayComponent;
